import wixLocation from 'wix-location';
import wixWindow from 'wix-window';
import wixData from 'wix-data';
import wixBookings from 'wix-bookings';
import wixUsers from 'wix-users';
import { getUser } from 'backend/profile';
import { updateUser } from 'backend/profile';


let wixProduct, customProduct;
//let bookingCollections = "4b1b356c-4dbb-ac0f-9528-c673d5b79265";
let picnicsCollection = "b06a68e9-5428-2c82-55a4-0d1c3bdd3161",
    toursCollection = "a29b035c-a254-fb1f-5325-0ad9ae99e5e7",
    workshopsCollection = "13597ab6-0995-a3fd-576d-a00faa50c6cc";

let selectedSlot;
let isBooking;
let user;
let arrRelevantCollections = ["13597ab6-0995-a3fd-576d-a00faa50c6cc", "a29b035c-a254-fb1f-5325-0ad9ae99e5e7", "b06a68e9-5428-2c82-55a4-0d1c3bdd3161"];

$w.onReady(function () {
    checkForBookingProduct();
});

// DECIDE WHAT PRODUCT TO SHOW

async function checkForBookingProduct() {
    let slug = wixLocation.path[1];
    console.log(slug);
    wixProduct = await wixData.query("Stores/Products").eq("slug", decodeURI(slug)).include("collections").find().then(res => res.items[0]);
    console.log("wixProduct", wixProduct);
    if (wixProduct.collections.some(collection => collection._id === picnicsCollection || collection._id === toursCollection || collection._id === workshopsCollection)) {
        let filter = wixData.filter().eq("storeItem", wixProduct._id);
        await $w("#dataset").setFilter(filter);
        customProduct = $w("#dataset").getCurrentItem();
        console.log("customProduct", customProduct);
        showCustomProduct();
    } else {
        showWixProduct();
    }
}

function showWixProduct() {
    //hide preloader
    $w("#multistateBox").collapse();
    //Show wix product and related
    $w("#stripWixProduct, #stripRelatedWix").expand();
}

function showCustomProduct() {
    //hide wix Product and related
    console.log("wixProduct3", wixProduct);
    $w("#stripWixProduct, #stripRelatedWix").collapse();
    // Multilingual
    let name, description;
    if (wixWindow.multilingual.currentLanguage === "he") { //hebrew
        name = wixProduct.name;
        description = wixProduct.description;
    } else {
        name = customProduct?.name || wixProduct.name;
        description = customProduct?.description || wixProduct.description;
    }
    $w("#name").text = name;
    $w("#desc").html = description;
    //hide preloader
    $w("#multistateBox").changeState("CustomProduct");
    //Show custom product and related custom	
    $w("#stripCustomProduct, #stripRelatedCustom").expand();
    initializeCustomProduct();
}

async function initializeCustomProduct() {
    //calendar    
    initializeEvents(customProduct.bookingItem);
    console.log('booking item', customProduct.bookingItem);
    let today = new Date();
    $w("#calendar").disabledDates = [today];
    let endRange = new Date();
    endRange.setDate(today.getDate() + 45);
    $w("#calendar").value = today;
    $w("#calendar").minDate = today;
    $w("#calendar").maxDate = endRange;
    

    //specific producs
    //Beginners mind:
    // if(wixProduct._id =="b36d4a46-c397-6650-d76c-d4fb7721b3fa"){
    //     let notAvailableDate1 = new Date(2021, 9, 8);
    //     let notAvailableDate2 = new Date(2021, 9, 22);
    //     let notAvailableDate3 = new Date(2021, 9, 29);
    //     let notAvailableDate4 = new Date(2021, 10, 5);
    //     let notAvailableDate5 = new Date(2021, 10, 12);
    //     let notAvailableDate6 = new Date(2021, 10, 19);
    //     $w("#calendar").disabledDates = [notAvailableDate1, notAvailableDate2, notAvailableDate3, notAvailableDate4, notAvailableDate5, notAvailableDate6];
    // }
    //product    
    console.log("wixProduct2", wixProduct)
    initializeRelated(wixProduct);
    //image
    $w("#mainMedia").fitMode = "fill";

    //get full booking product
    let serviceTitle;
    let storeBooking = await wixData.get("Bookings/Services", customProduct.bookingItem);
    console.log("storeBookings", storeBooking);
    customProduct = { ...customProduct, "bookingItem": storeBooking };
    console.log("customProduct", customProduct);
    let serviceId;
    serviceId = customProduct.bookingItem._id;
    serviceTitle = customProduct.bookingItem.serviceName;
    setCalendar(serviceId);
    isBooking = true;
    $w("#groupBooking").expand();
    $w("#calendar").show();
    setTodaySlots(serviceId);
    if (!wixUsers.currentUser.loggedIn) {
        $w("#groupBooking").collapse();
        $w("#submit").label = wixWindow.multilingual.currentLanguage === "he" ? "התחברות" : "login"
        $w("#submit").onClick(async (event) => {
            wixUsers.promptLogin()
                .then((user) => wixLocation.to(wixLocation.url))
                .catch((err) => wixLocation.to("/פיקניק-ומפגשים-בחווה"));//if user does not login, send to All Bookings
        });
    } else submitButtonHandler(serviceId, serviceTitle);   
}

function initializeEvents(serviceId) {
    //login / signup
    user = wixUsers.currentUser;
    if (user.loggedIn) {
        getUser(user.id)
            .then((user2) => {
                user = user2;
                if (user.memberName) {
                    $w("#inputName").value = user.memberName;
                }
                if (user2.emails.length > 0) {
                    $w("#inputEmail").value = user.emails[0];
                }
                if (user2.phones.length > 0) {
                    $w("#inputPhone").value = user.phones[0];
                }
            });
    }

    //has next?
    wixData.query("Stores/Products").hasSome("collections", arrRelevantCollections).find()
        .then(async (results) => {
            let length = results.items.length;
            for (let i = 0; i < length; i++) {
                let item = results.items[i];
                if (wixProduct._id === item._id) {
                    let nextItem = results.items[i + 1];
                    if (!nextItem) {
                        $w("#next").disable();
                    } else {
                        $w("#next").enable();
                    }
                }
            }
        })
        .catch((err) => {
            console.log(err);
        })

    //has prev?
    wixData.query("Stores/Products").hasSome("collections", arrRelevantCollections).find()
        .then(async (results) => {
            let length = results.items.length;
            for (let j = length - 1; j >= 0; j--) {
                let item = results.items[j];
                if (wixProduct._id === item._id) {
                    let prevItem = results.items[j - 1];
                    if (!prevItem) {
                        $w("#prev").disable();
                    } else {
                        $w("#prev").enable();
                    }
                }
            }
        })
        .catch((err) => {
            console.log(err);
        })

    //next
    $w("#next").onClick(async (event) => {
        wixData.query("Stores/Products").hasSome("collections", arrRelevantCollections).find()
            .then(async (results) => {
                let length = results.items.length;
                for (let i = 0; i < length; i++) {
                    let item = results.items[i];
                    if (wixProduct._id === item._id) {
                        let nextItem = results.items[i + 1];
                        wixLocation.to("/products/" + nextItem.slug)
                    }
                }
            })
            .catch((err) => {
                console.log(err);
            })
    })
    //prev
    $w("#prev").onClick(async (event) => {
        wixData.query("Stores/Products").hasSome("collections", arrRelevantCollections).find()
            .then(async (results) => {
                let length = results.items.length;
                for (let j = length - 1; j >= 0; j--) {
                    let item = results.items[j];
                    if (wixProduct._id === item._id) {
                        let prevItem = results.items[j - 1];
                        wixLocation.to("/products/" + prevItem.slug)
                    }
                }
            })
            .catch((err) => {
                console.log(err);
            })
    })
    //calendar
    $w("#calendar").onChange((event) => {
        let now = new Date();
        let tomorrow = new Date(now.setDate(now.getDate() + 1));
        let selectedDate = new Date();
        selectedDate = $w("#calendar").value;
        if (selectedDate < tomorrow) {
            console.log(selectedDate, tomorrow);
            $w("#err24").show();
            setTimeout(function () {
                $w("#err24").hide();
                $w("#dropTime").value = "";
            }, 6000);
        } else {
            setTime(serviceId);
        }
    });
    //ribbon
    let ribbon = wixProduct.ribbons;
    //console.log("ribbon: " + ribbon);
    let ribbonText = ribbon[0]?.text;
    //console.log("ribbonText : " + ribbonText);
    if (ribbonText !== null) {
        $w('#textRibbon').text = ribbonText;
        $w("#boxRibbon").show();
    }
}

function submitButtonHandler(serviceId, serviceTitle) {
    $w("#submit").onClick(async (event) => {
        $w("#submit").disable();
        //validation
        //set require
        $w("#calendar").required = true;
        $w("#dropTime").required = true;
        $w("#inputName").required = true;
        $w("#inputPhone").required = true;
        $w("#inputEmail").required = true;

        if ($w("#calendar").valid && $w("#dropTime").valid && $w("#inputName").valid && $w("#inputPhone").valid && $w("#inputEmail").valid) {
            let now = new Date();
            //let tomorrow = new Date(now.setDate(now.getDate() + 1)); //change this to be 18 hours
            let tomorrow = new Date(now.setHours(now.getHours() + 18)); //18 hours
            let selectedDate = new Date();
            selectedDate = $w("#calendar").value; //change this to include the selected time
            selectedDate.setHours(Number($w("#dropTime").value.slice(0, 2)), Number($w("#dropTime").value.slice(3, 5)), 0, 0);
            console.log("selectedDate", selectedDate);
            if (selectedDate < tomorrow) {
                console.log(selectedDate, tomorrow);
                $w("#err24").show();
                setTimeout(function () {
                    $w("#err24").hide();
                    $w("#dropTime").value = "";
                }, 6000);
            } else {
                let quantity = Number($w("#quantity").value);
                updateUser(user.id, $w("#inputName").value, $w("#inputEmail").value, $w("#inputPhone").value)
                    .then(() => {
                        console.log("member updated");
                    })

                if (isBooking) {
                    //date time
                    let calendar = new Date();
                    calendar = $w("#calendar").value;
                    let range = $w("#dropTime").value;
                    console.log("range: " + JSON.stringify(range));
                    if (range) {
                        let startRange = range.slice(0, 5);
                        console.log("startRange: " + startRange);
                        let hours = startRange.slice(0, 2);
                        console.log("s hours: " + hours);
                        let numHours = Number(hours);
                        let minutes = startRange.slice(3, 5);
                        console.log("s minutes: " + minutes);
                        let numMinutes = Number(minutes);
                        calendar.setHours(numHours);
                        calendar.setMinutes(numMinutes);
                        let dateStartRange = new Date(calendar);
                        console.log("dateStartRange: " + dateStartRange);

                        let endRange = range.slice(8, 13);
                        console.log("e endRange: " + endRange);
                        hours = endRange.slice(0, 2);
                        console.log("e hours: " + hours);
                        numHours = Number(hours);
                        minutes = endRange.slice(3, 5);
                        console.log("e minutes: " + minutes);
                        numMinutes = Number(minutes);
                        calendar.setHours(numHours);
                        calendar.setMinutes(numMinutes);
                        let dataEndRange = new Date(calendar);
                        console.log("dateStartRange: " + dateStartRange);

                        let options = {
                            startDateTime: dateStartRange,
                            endDateTime: dataEndRange
                        };

                        console.log("options: " + JSON.stringify(options));

                        let availability = await wixBookings.getServiceAvailability(serviceId, options)
                            .catch(err => {
                                console.log("error getting availability", err);
                                $w("#errSlots").show();
                                setTimeout(function () {
                                    $w("#errSlots").hide();
                                }, 6000);
                            })
                        console.log("availability: ", availability);
                        if (availability) {
                            let slots1 = availability.slots[0];
                            quantity = Number($w("#quantity").value);
                            if (slots1.remainingSpots >= quantity) {
                                let when = dateStartRange.toLocaleDateString() + ", " + dateStartRange.toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' }) + " - " + dataEndRange.toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' });
                                console.log("when", when);
                                selectedSlot = slots1;
                                console.log("selectedSlot: ", selectedSlot);
                                let customOptions = {
                                    "customTextFields": [{
                                        "title": "Booking",
                                        "value": when
                                    }]
                                };

                                let quantity = Number($w("#quantity").value);
                                selectedSlot = JSON.stringify(selectedSlot);
                                console.log("selectedSlot Stringified: " + selectedSlot);
                                $w("#myShoppingCartIcon").addToCart(wixProduct._id, quantity, getCostumeOption(customOptions) ) //,customOptions
                                    .then(() => {
                                        let email = $w("#inputEmail").value;
                                        let phone = $w("#inputPhone").value;
                                        let name = $w("#inputName").value;

                                        //add to booking cart
                                        let toInsert = {
                                            "user": user.id,
                                            "email": email,
                                            "phone": phone,
                                            "fullName": name,
                                            "title": serviceTitle,
                                            "product": wixProduct._id,
                                            "booking": serviceId,
                                            "slot": selectedSlot,
                                            "quantity": quantity,
                                        }
                                        console.log("toInsert: ", toInsert);
                                        wixData.insert("storeBookingsOrders", toInsert)
                                            .then(() => {
                                                console.log("booking added to bookingCart");
                                                $w("#submit").enable();
                                            })
                                            .catch((err) => {
                                                console.log(err);
                                            });
                                    })
                                    .catch((err) => {
                                        console.log(err);
                                    });
                            } else {
                                $w("#errSlots").show();
                                setTimeout(function () {
                                    $w("#errSlots").hide();
                                }, 6000);
                                 $w("#submit").enable();
                            }
                        }                        
                    } else {
                        $w("#err").show();
                        setTimeout(function () {
                            $w("#err").hide();
                        }, 4000);
                         $w("#submit").enable();
                    }

                } else {     
                  
                    quantity = Number($w("#quantity").value);

                  
                    $w("#myShoppingCartIcon").addToCart(wixProduct._id, quantity)
                        .then(() => {
                            console.log("product added to store cart");
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                         $w("#submit").enable();
                }
            }
        } else {
            $w("#err").show();
            setTimeout(function () {
                $w("#err").hide();
            }, 4000);
             $w("#submit").enable();
        }
    })
}
function getCostumeOption(customOptions){
    return customOptions;
}
// CUSTOM PRODUCT FUNCTIONALITY



export function setCalendar(serviceId) {
    let arrisabledDaysofWeek = [];
    wixData.query("Bookings/Schedule").eq("_id", serviceId).find()
        .then((results) => {
            let length = results.items.length;

            console.log("length1:"+length);
            if (length > 0) {
                console.log("length2:"+length);
                let schedule = results.items[0].serviceSchedule;
                
                let sun = schedule.sun;
                let mon = schedule.mon;
                let tue = schedule.tue;
                let wed = schedule.wed;
                let thu = schedule.thu;
                let fri = schedule.fri;
                let sat = schedule.sat;

                if (sun.length === 0) { arrisabledDaysofWeek.push(0); }
                if (mon.length === 0) { arrisabledDaysofWeek.push(1); }
                if (tue.length === 0) { arrisabledDaysofWeek.push(2); }
                if (wed.length === 0) { arrisabledDaysofWeek.push(3); }
                if (thu.length === 0) { arrisabledDaysofWeek.push(4); }
                if (fri.length === 0) { arrisabledDaysofWeek.push(5); }
                if (sat.length === 0) { arrisabledDaysofWeek.push(6); }
                $w("#calendar").disabledDaysOfWeek = arrisabledDaysofWeek;

                let reaptingByProductOptions = wixProduct.customTextFields[0].title;
                let storeBookingTagLine = customProduct.bookingItem.tagLine;
                let firstAbleDate = new Date(storeBookingTagLine);
                let currentMonth = firstAbleDate.getMonth();
                let currentYear = firstAbleDate.getFullYear();

                let days7 = new Date(currentYear,currentMonth,firstAbleDate.getDate() + 7 );
                let days14 = new Date(currentYear,currentMonth,firstAbleDate.getDate() + 14 );
                let days21 = new Date(currentYear,currentMonth,firstAbleDate.getDate() + 21 );
                let days28 = new Date(currentYear,currentMonth,firstAbleDate.getDate() + 28 );
                let days35 = new Date(currentYear,currentMonth,firstAbleDate.getDate() + 35 );
                let days42 = new Date(currentYear,currentMonth,firstAbleDate.getDate() + 42 );
                let days49 = new Date(currentYear,currentMonth,firstAbleDate.getDate() + 49 );
                let days56 = new Date(currentYear,currentMonth,firstAbleDate.getDate() + 56 );

                switch(reaptingByProductOptions){
                    case '0':
                        $w("#calendar").minDate = firstAbleDate;
                        $w("#calendar").maxDate = firstAbleDate;
                        break;
                    case '1':
                            $w("#calendar").minDate = firstAbleDate;
                            break;
                    case '2':
                        $w("#calendar").minDate = firstAbleDate;
                        $w("#calendar").disabledDates = [days7, days21, days35, days49];
                        break;
                    case '3':
                        $w("#calendar").minDate = firstAbleDate;
                        $w("#calendar").disabledDates = [days7, days14, days28, days35, days49, days56];
                        break;
                    case '4':
                        $w("#calendar").minDate = firstAbleDate;
                        $w("#calendar").disabledDates = [days7, days14, days21, days35, days42, days49];
                        break;
                    default:
                        console.log("Please change to 0-4 num");
                }

                // console.log("productType:" + productType);
                // let repeating = results.items[0].repeatsEveryXWeeks;
                // if( repeating == 2 || repeating == 0){
                //     let onlyAbleDate = new Date(storeBookingTagLine);
                //     let endRange = new Date();
                //     endRange.setDate(onlyAbleDate.getDate() + 6);
                //     $w("#calendar").minDate = onlyAbleDate;
                //     $w("#calendar").maxDate = endRange;
                // }

            }
        })
        .catch((err) => {
            console.log("err: " + err);
        });
}

export function setTime(serviceId) {
    let arrTime = [];
    let selectedDate = new Date();
    selectedDate = $w("#calendar").value;

    let dateTimeStart = new Date(getDayStart(selectedDate));
    let dateTimeEnd = new Date(getDayEnd(selectedDate));
    console.log("dateTimeEnd: " + dateTimeEnd);

    let slotsOptions = {
        startDateTime: dateTimeStart,
        endDateTime: dateTimeEnd
    };

    wixBookings.getServiceAvailability(serviceId, slotsOptions)
        .then((availability1) => {
            let slots = availability1.slots;
            let length = slots.length;
            for (let q = 0; q < length; q++) {
                let slot = slots[q];
                let stringStart = String(slot.startDateTime);
                let stringEnd = String(slot.endDateTime);
                stringStart = stringStart.slice(16, 21);
                stringEnd = stringEnd.slice(16, 21);
                let value = stringStart + " - " + stringEnd;
                arrTime.push({ "value": value, "label": stringStart + "-" + stringEnd });
            }
            arrTime.sort();
            if (length > 0) {
                $w("#dropTime").options = arrTime;
                $w("#dropTime").value = arrTime[0].value;
            } else {
                $w("#dropTime").options = [];
                $w("#dropTime").value = "";
                $w("#errNoSlots").show();
                setTimeout(function () {
                    $w("#errNoSlots").hide();
                    $w("#dropTime").value = "";
                }, 4000);
            }
        })
        .catch((err) => {
            console.log("err: " + err);
        });
}

export function setTodaySlots(serviceId) {
    let arrTime = [];
    let now = new Date();
    let twentyFourHoursfromNow = new Date(now.setHours((now.getHours() + 24)));
    console.log("# " + twentyFourHoursfromNow);

    let dateTimeStart = new Date(twentyFourHoursfromNow);
    let trempEnd = new Date(twentyFourHoursfromNow.setHours(23));
    let dateTimeEnd = new Date(trempEnd.setMinutes(59));

    let slotsOptions = {
        startDateTime: dateTimeStart,
        endDateTime: dateTimeEnd
    };

    console.log("dateTimeStart: " + dateTimeStart);
    console.log("dateTimeEnd: " + dateTimeEnd);

    wixBookings.getServiceAvailability(serviceId, slotsOptions)
        .then((availability1) => {
            let slots = availability1.slots;
            let length = slots.length;
            for (let q = 0; q < length; q++) {
                let slot = slots[q];
                let stringStart = String(slot.startDateTime);
                let stringEnd = String(slot.endDateTime);
                stringStart = stringStart.slice(16, 21);
                stringEnd = stringEnd.slice(16, 21);
                let value = stringStart + " - " + stringEnd;
                arrTime.push({ "value": value, "label": stringStart + "-" + stringEnd });
            }
            arrTime.sort();
            if (length > 0) {
                $w("#dropTime").options = arrTime;
                $w("#dropTime").value = arrTime[0].value;
            } else {
                $w("#dropTime").options = [];
                $w("#dropTime").value = "";
            }
        })
        .catch((err) => {
            console.log("err: " + err);
        });
}

export function getDayStart(myDate) {
    console.log("myDate: " + myDate);
    let dateTimeStart = new Date(myDate);
    console.log("dateTimeStart: " + dateTimeStart);
    dateTimeStart = $w("#calendar").value;
    dateTimeStart.setHours(0);
    dateTimeStart.setMinutes(0);
    return dateTimeStart;
}

export function getDayEnd(myDate) {
    let dateTimeEnd = new Date(myDate);
    dateTimeEnd = $w("#calendar").value;
    dateTimeEnd.setHours(23);
    dateTimeEnd.setMinutes(59);
    return dateTimeEnd;
}

// RELATED PRODUCTS

async function initializeRelated(item) {
    $w("#repeater").data = [];
    console.log("item", item);
    let relatedItems = await wixData.query("RelatedProducts").eq("mainProduct", item._id).find().then(res => res.items);
    console.log("relatedItems", relatedItems);
    if (relatedItems.length > 0) populateRepeater(relatedItems);

    wixLocation.onChange((location) => {
        initializeRelated();
    });

    $w("#repeater").onItemReady(($item, itemData, index) => {
        $item("#imageRelated").src = itemData.mainMedia;
        $item("#imageRelated").link = itemData.productPageUrl;
        $item("#textTitleRelated").text = itemData.name;
        $item("#textPriceRelated").text = itemData.formattedDiscountedPrice;
    });
}

async function populateRepeater(relatedItems) {
    let fullRelatedItems = await wixData.queryReferenced("RelatedProducts", relatedItems[0]._id, "relatedProducts").then(res => res.items);
    console.log("fullRelatedItems", fullRelatedItems);
    $w("#repeater").data = fullRelatedItems;
    $w("#stripRelatedCustom").expand();
}

export function buttonRelatedAddToCart_click(event) {
    console.log(event);
    $w("#myShoppingCartIcon").addToCart(event.context.itemId, 1)
        .then(() => {
            console.log("product added to store cart");
        })
        .catch((err) => {
            console.log(err);
        });
}